var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.datas && _vm.show)?_c('span',{staticClass:"tagWrap"},[_c('span',{class:['single-tag', _vm.datas.mktFrontType ? 'tag' + _vm.datas.mktFrontType : '', _vm.CookiesOne && _vm.CookiesOne == 'en-US' ? ' tagEn' : '', _vm.putName ? 'tag' + _vm.putName : ''],style:(_vm.getCss(_vm.datas))},[_c('span',[_vm._v(_vm._s(_vm.getText(_vm.datas)))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }